import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { parseErrors, Toast } from 'helpers';
import { getJobTickets } from 'queries';
import { JsonDataItem } from 'types';

export const useJobTickets = (status: '0' | '1' | null, jobId?: string) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(5);
  const { data, isInitialLoading: isLoading } = useQuery(
    [
      'get-tickets',
      'job',
      jobId,
      {
        currentPage,
        recordsPerPage,
        status,
      },
    ],
    getJobTickets,
    {
      enabled: !!jobId,
      onError: (error: JsonDataItem) => {
        Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
      },
    },
  );

  const paginationMetadata = {
    total: data?.meta?.total || 0,
    current_page: currentPage,
    pageSize: 5,
    onChange: (page: number, pageSize: number) => {
      setCurrentPage(page);
      setRecordsPerPage(pageSize);
    },
  };

  return {
    tickets: data?.data,
    isTicketsLoading: isLoading,
    paginationMetadata,
  };
};
